import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { apiFunction, createRequestData, URL } from "./utils";

const authApi = createApi({
  reducerPath: "auth",
  baseQuery: fetchBaseQuery({
    baseUrl: `${URL.url}`,
    fetchFn: async (...args) => {
      // REMOVE FOR PRODUCTION
      return fetch(...args);
    },
  }),
  tagTypes: "Auth",
  endpoints(builder) {
    return {
      forgotPassword: builder.mutation({
        query: (data) => {
          const { token, ...filteredData } = data;
          const requestData = createRequestData({
            ...filteredData,
          });
          return {
            url: `/api/users/forgot-password`,
            method: "POST",
            body: {
              ...requestData,
            },
          };
        },
      }),
      login: builder.mutation({
        query: (data) => {
          const { token, ...filteredData } = data;
          const requestData = createRequestData({
            ...filteredData,
          });
          return {
            url: `/api/users/login`,
            method: "POST",
            body: {
              ...requestData,
            },
          };
        },
      }),

      logout: builder.mutation({
        query: ({ token }) => {
          return apiFunction({ token }, "/api/users/logout", "POST");
        },
      }),
    };
  },
});

export const {
  useForgotPasswordMutation,
  useLoginMutation,
  useSendVerificationCodeMutation,
  useVerifyEmailCodeMutation,
  useLogoutMutation,
} = authApi;
export { authApi };
